import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, DialogPosition, MatDialogRef } from '@angular/material';
import { DeleteDialogComp } from './dialog';

@Injectable({
	providedIn: 'root'
})
export class DialogService {
	constructor(private dialog: MatDialog) { }

	openDialog(component, data?: any, position?: DialogPosition, size?): MatDialogRef<any> {
		let dialogConfig = new MatDialogConfig();
		if (position)
			dialogConfig.position = position;
		if (data)
			dialogConfig.data = data;

		dialogConfig.hasBackdrop = false;
		dialogConfig.panelClass = "customDialog";

		let dialog = this.dialog.open(component, dialogConfig);

		return dialog;

	}
	closeDialog() {
		this.dialog.closeAll();
	}
	openDelete(data, onSuccess): void {
		let dialogRef = this.dialog.open(DeleteDialogComp, data);
		dialogRef.afterClosed().subscribe(result => {
			if (result)
				onSuccess(data)
		});
	}
}
